import { useStore } from '@stores';

export const useTenantLabour = () => {
  const { sessionStore } = useStore();

  return sessionStore.currentLogin?.tenant?.labourRate;
};
